import {
  Breadcrumbs,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import React, { useContext, useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import { emphasize, styled } from "@mui/material/styles";
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MyContext } from "../../App";
import { deleteData, fetchDataFromApi } from "../../utils/api";
import { FaPencilAlt } from "react-icons/fa";

// ================= Breadcrumb =================
const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];

  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

// ================= Component =================
const VariantGroup = () => {
  const [variantGroupData, setVariantGroupData] = useState([]);

  // 🔥 dialog states
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const context = useContext(MyContext);

  // ================= Fetch =================
  useEffect(() => {
    window.scrollTo(0, 0);

    context.setProgress(20);

    fetchDataFromApi("/api/variantGroup").then((res) => {
      setVariantGroupData(res);
      context.setProgress(100);
    });
  }, []);

  // ================= Open dialog =================
  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setOpenDelete(true);
  };

  // ================= Confirm delete =================
  const confirmDelete = () => {
    context.setProgress(40);

    deleteData(`/api/variantGroup/${selectedId}`)
      .then(() => {
        context.setProgress(100);

        context.setAlertBox({
          open: true,
          error: true,
          msg: "Variant Group Deleted!",
        });

        fetchDataFromApi("/api/variantGroup").then((res) => {
          setVariantGroupData(res);
        });

        setOpenDelete(false);
      })
      .catch((err) => {
        console.error("Error deleting variantGroup:", err);
      });
  };

  return (
    <>
      <div className="right-content w-100">
        {/* ================= Header ================= */}
        <div className="card shadow border-0 w-100 flex-row p-4">
          <h5 className="mb-0">Variant Group List</h5>

          <div className="ml-auto d-flex align-items-center">
            <Breadcrumbs aria-label="breadcrumb" className="ml-auto breadcrumbs_">
              <StyledBreadcrumb
                component="a"
                href="#"
                label="Dashboard"
                icon={<HomeIcon fontSize="small" />}
              />
              <StyledBreadcrumb
                label="Variant Group"
                deleteIcon={<ExpandMoreIcon />}
              />
            </Breadcrumbs>

            <Link to="/variantGroup/add">
              <Button className="btn-blue ml-3 pl-3 pr-3">
                Add Variant Group
              </Button>
            </Link>
          </div>
        </div>

        {/* ================= Table ================= */}
        <div className="card shadow border-0 p-3 mt-4">
          <div className="table-responsive mt-3">
            <table className="table table-bordered v-align">
              <thead className="thead-dark">
                <tr>
                  <th>VARIANT GROUP</th>
                  <th>ACTION</th>
                </tr>
              </thead>

              <tbody>
                {variantGroupData?.variantGroup?.length > 0 ? (
                  variantGroupData.variantGroup.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>

                      <td>
                        <div className="actions d-flex align-items-center">
                          <Link to={`/variantGroup/edit/${item._id}`}>
                            <Button className="success" color="success">
                              <FaPencilAlt />
                            </Button>
                          </Link>

                          <Button
                            className="error"
                            color="error"
                            onClick={() => handleDeleteClick(item._id)}
                          >
                            <MdDelete />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center">
                      No Variant Group Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ================= Delete Dialog ================= */}
      <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
        <DialogTitle>Delete Variant Group</DialogTitle>

        <DialogContent>
          Are you sure you want to delete this Variant Group?
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDelete(false)}>Cancel</Button>

          <Button
            color="error"
            variant="contained"
            startIcon={<MdDelete />}
            onClick={confirmDelete}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VariantGroup;

